import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CardComponent } from '@app/shared/components/card/card.component';

import * as _ from 'lodash-es';

@Component({
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss']
})
export class CardListComponent implements OnInit {
  @ContentChild('addButton', {static: false}) addButton: TemplateRef<any>;
  @ContentChild('cardItem', {static: false}) cardItem: TemplateRef<any>;
  @ContentChild('cardItemLoading', {static: false}) cardItemLoading: TemplateRef<any>;

  @ContentChildren(CardComponent) cards: QueryList<CardComponent>;

  @HostBinding('class.vertical') @Input() vertical = false;
  @HostBinding('class.carousel') @Input() carousel = false;
  @HostBinding('class.few') @Input() fewRecords = false;

  @Input() data: any[];
  @Input() showSearch = false;
  @Input() nextItemsLoading = false;

  @Output() filterTextChange = new EventEmitter();

  filterText = '';
  searchForm: FormGroup;

  constructor(formBuilder: FormBuilder) {
    this.searchForm = formBuilder.group({
      search: ['']
    });
  }

  ngOnInit() {
  }

  isVisible() {
    return this.showSearch || !_.isEmpty(this.filterText);
  }

  onFilterTextChange(text: string) {
    this.filterText = text;
    this.filterTextChange.emit(text);
  }

  doSearch(text) {
    this.cards.forEach((item: CardComponent) => {

      if (!text) {
        item.show();
        return;
      }

      const title = item.getTitle();
      if (title.startsWith(text)) {
        item.show();
      } else {
        item.hide();
      }
    });
  }
}
